import {  useAppDispatch,useAppSelector } from "../../../../../../redux/hooks"
import { SetCloud } from '../../../../../../redux/feature/CloudSlice'
import { useEffect } from "react"

export default function SelectCloud(props:any) {
  const Type = useAppSelector(state => state.CloudSlice.Type)

  const dispatch = useAppDispatch()
  useEffect(() => {
    const storedCloud = localStorage.getItem('cloud');
    if (storedCloud) {
      dispatch(SetCloud(storedCloud));
    }
  }, [dispatch]);

  const handleCloudChange = (e:any) => {
    const selectedCloud = e.target.value;
    dispatch(SetCloud(selectedCloud));
    localStorage.setItem('cloud', selectedCloud);
  };


    return(  
    <div>
      <label className=' fw-bolder  fs-7 mb-0 '>Cloud</label>
        <select 
        style={{height:'auto',paddingTop:'0', paddingBottom:'0'}}
        required
        className="form-select form-select-solid bg-light-info text-info border-gray-400 w-100px" aria-label="Select example" value={Type}
        onChange={handleCloudChange}>
             <option className="text-info" value="Global">Global</option>
             <option className="text-info" value="AWS">AWS</option>
             <option className="text-info" value="OCI">OCI</option>
             <option className="text-info" value="AZR">AZR</option>
             <option className="text-info" value="GCP">GCP</option>
        </select>
    </div>
      
    )
    
}